define('views/modules/member/group/lists/group-list-item',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'bootbox',
    // models
    'collections/commons/locales',
    //services
    'services/events/user-events',
    'services/i18n',
    'services/api',
    // views
    'views/parts/menu/menu',
    'views/parts/menu/menu-context',
    'views/parts/media-info-box',
    // 'views/modules/profile/profile-minimal-edit',
    // templates
    'text!templates/modules/member/group/lists/group-list-item.html'
], function(
    // Libs
    $, _, Backbone, Mustache, U, Bootbox,
    // models
    CLocales,
    // services
    UserEvents,
    i18n,
    API,
    // views
    VMenu,
    VMenuContext,
    VMediaInfoBox,
    // VProfileMinimalEdit,
    // templates
    TGroupListItem
) {

    var VGroupItem = Backbone.View.extend({
        template: TGroupListItem,
        events: {
            'click .options-toggle': 'onMenuOptionToggle',
        },

        regions: {
            infobox: ".item-section",
            subSection: ".sub-section",
            menu: ".menu-options",
        },
        initialize: function(opt) {
            this.options = opt || {};

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    //subtitle: 'description',
                    tinyinfo: false,
                    context: this,
                    onClick: this.onClick,
                    //extraPhotoContent: true,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    },
                    model: this.model
                }),
            };

            this.listenTo(this.model, {
                // 'change': this.onModelChange,
                'active': this.setActive
            });

        },
        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones()
                .assign(this.view.infobox, this.zone.$infobox);

            this.zone.$menu = this.$(this.regions.menu);

            return this;
        },

        setActive: function(val) {
            this.zone.$infobox.toggleClass('active', val);
        },

        deleteGroup: function(result) {
            if (!result) return;

            //The API need a querystring parameter to know what to do with the group members.
            //Possible value "move"(move users in parent group), "delete"(Delete only the group and do nothing with the users)
            var urlDelete = API.url(Mustache.render('groups/{{{groupId}}}?members=move', {
                groupId: this.model.get("_id")
            }));

            this.model.destroy({
                url: urlDelete,
                context: this,
                wait: true,
                success: function(model) {
                  UserEvents.groupModify(this.model);
                },
                error: function(model, response) {
                    // FIXME add error notification when member deletion failed
                    if (response.responseJSON) {
                        U.warn(response.responseJSON.message);
                    }
                }
            });

        },

        toggleEditForm: function(val) {

        },

        onMenuInit: function() {
            var menuActions = new Backbone.Collection();

            menuActions.add([
                { caption: 'Edit', icon: "sl-icon-note", callback: this.onClick }
            ]);
            if (!this.model.isTopLevelFirstGroup())
                  menuActions.add([{ caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }]);

            return menuActions;
        },

        ////////////
        // events //
        ////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onClick: function(e) {
            e.preventDefault();
            if (!this.$(e.target).hasClass('options-toggle')) {
                this.$('.item-section.active').removeClass('active');
                UserEvents.editGroup(this.model, e);
                this.setActive(true);
            }
        },

        onMenuOptionToggle: function(e) {
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete group"),
                message: i18n.t("messages:message-delete-group"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteGroup,
                context: this,
            });
        },

        onOptionClicked: function(e, optionModel) {
            e.preventDefault();
            e.stopPropagation();
        },

    });

    return VGroupItem;

});

